
    import { mapState, mapGetters } from 'vuex';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faLockAlt as farLockAlt,
    } from '@fortawesome/pro-regular-svg-icons/faLockAlt';

    import {
        faUp as fasUp,
    } from '@fortawesome/pro-solid-svg-icons/faUp';

    import Histogram from '@/components/JobView/Histogram/Histogram';
    import SeekerAvatar from '@/components/Seeker/SeekerAvatar';
    import JobViewChartModal from '@/components/JobView/JobViewChartModal';
    import JobViewPayTable from '@/components/JobView/JobViewPayTable';

    export default {
        name: 'JobViewPayComparison',

        components: {
            Histogram,
            SeekerAvatar,
            JobViewChartModal,
            JobViewPayTable,
            FontAwesomeIcon,
        },

        props: {
            hideCta: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                showProfileModal: false,
                showPromptModal: false,
                onBoardingPrompt: {
                    component_name: 'OnBoardingPrompt',
                    layout: 'lg',
                    code: 'ON_BOARDING_PROMPT',
                    page_referral_element: 'profile_value',
                },
                icons: {
                    farLockAlt,
                    fasUp,
                },
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
            }),

            ...mapGetters('job', {
                $_pay: 'pay',
                $_payLabel: 'payLabel',
                $_marketPay: 'marketPay',
                $_marketAveragePayShortLabel: 'marketAveragePayShortLabel',
                $_occupationLabel: 'occupationLabel',
                $_locationLabel: 'locationLabel',
                $_isPayAboveAvg: 'isPayAboveAvg',
                $_showChart: 'showChart',
                $_payData: 'payData',
                $_chartType: 'chartType',
            }),

            table() {
                return [
                    {
                        label: this.$_pay.$isPayEstimated ? 'Similar jobs pay' : `${this.$_payLabel} range`,
                        figure: this.$_pay.payMinMaxShortLabelRange,
                        variant: 'secondary',
                        is_dark: true,
                    },
                    {
                        label: 'Market average',
                        figure: this.$_marketAveragePayShortLabel,
                        variant: '',
                        is_dark: false,
                    },
                ];
            },
        },

        methods: {
            openProfileModal() {
                this.showProfileModal = true;
            },

            closeProfileModal() {
                this.showProfileModal = false;
            },

            openPromptModal() {
                this.showPromptModal = true;
            },

            closePromptModal() {
                this.showPromptModal = false;
            },

            onPromptSuccess() {
                this.openProfileModal();
            },
        },
    };
